import requestModel from "services/config/apiHandlers";

class Archives {
  constructor(requsetObj) {
    this.requsetObj = requsetObj;
    this.url = "api/archives";
    this.downloadUrl = "download/";
  }

  async postArchives() {
    const apiObj = {
      url: this.url,
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async postArchivesWithFile() {
    const apiObj = {
      url: this.url + "/file",
      method: "post",
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async getArchives(params) {
    const apiObj = {
      url: this.url,
      reqObj: this.requsetObj,
      params,
    };

    return await requestModel.response(apiObj);
  }

  async getDownloadTextArchives(downloadLink) {
    const apiObj = {
      url: this.downloadUrl + downloadLink,
      responseType: "arraybuffer",
    };

    return await requestModel.response(apiObj);
  }

  async getSingleArchives(url) {
    const apiObj = {
      url: this.url + "/" + url,
    };

    return await requestModel.response(apiObj);
  }

  async patchFeedback(url) {
    const apiObj = {
      method: "patch",
      url: `${this.url}/${url}/feedback`,
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async patchEditTitle(id) {
    const apiObj = {
      method: "patch",
      url: `${this.url}/${id}`,
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async patchEditAiResult(id) {
    const apiObj = {
      method: "patch",
      url: `${this.url}/${id}/edit-ai-result`,
      reqObj: this.requsetObj,
    };

    return await requestModel.response(apiObj);
  }

  async removeItem(id) {
    const apiObj = {
      method : "delete",
      url : `${this.url}/${id}`,
    };

    return await requestModel.response(apiObj);
  }
}

export default Archives;
